import { useDispatch, useSelector } from 'react-redux';
import { useAdminSlice } from '../slice';
import { selectSelectedUserToView } from '../slice/selectors';

export default function useUserSessionsListHandler() {
  const dispatch = useDispatch();
  const { actions } = useAdminSlice();
  const selectedUserToView = useSelector(selectSelectedUserToView);

  const setSelectedUserToView = (userId: string | null) => {
    dispatch(actions.setSelectedUserToView(userId));
  };

  return { selectedUserToView, setSelectedUserToView };
}
